import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CommunicationService } from '../services/communication.service';
import { SCREEN_SIZE } from '../classes/enums';
import { first } from 'rxjs/operators';

@Injectable()
export class ScreenSizeResolver implements Resolve<SCREEN_SIZE> {

  constructor(private _communicationService: CommunicationService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<SCREEN_SIZE> {
    return this._communicationService.screenSize.pipe(first());
  }
}
